import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <SectionWrapper id="testimonios" withGlow data-id="element-443">
      <div className="max-w-4xl mx-auto" data-id="element-444">
        <div className="text-center mb-16" data-id="element-445">
          <p className="text-[#c9a84c] text-sm font-semibold tracking-[0.2em] uppercase mb-6" data-id="element-446">
            Historias reales
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#e8e6e1] mb-4" data-id="element-447">
            Personas que{' '}
            <span className="text-gold-gradient" data-id="element-448">ya se transformaron</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-449">
          {/* Testimonial 1 */}
          <div className="p-6 md:p-8 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 relative" data-id="element-450">
            <QuoteIcon className="w-8 h-8 text-[#c9a84c]/20 absolute top-6 right-6" aria-hidden="true" data-id="element-451" />
            <div className="flex items-center gap-3 mb-5" data-id="element-452">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/30 to-[#252b45] flex items-center justify-center" data-id="element-453">
                <span className="text-[#c9a84c] font-bold text-sm" data-id="element-454">RM</span>
              </div>
              <div data-id="element-455">
                <p className="text-[#e8e6e1] font-semibold text-sm" data-id="element-456">
                  Roberto Martínez
                </p>
                <p className="text-[#6b6b7b] text-xs" data-id="element-457">Guadalajara, Jalisco</p>
              </div>
            </div>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-458">
              "Llevaba{' '}
              <span className="text-[#e8e6e1]" data-id="element-459">
                años empezando y dejando todo
              </span>
              . Cursos, gimnasio, proyectos... todo lo abandonaba. Este
              protocolo me hizo entender que el problema no era disciplina, era
              mi identidad. En 3 semanas mi esposa me dijo:{' '}
              <span className="text-[#c9a84c] italic" data-id="element-460">
                '¿Qué te pasó? Eres otra persona.'
              </span>
              "
            </p>
            <div className="flex gap-0.5 mt-4" data-id="element-461">
              {[1, 2, 3, 4, 5].map(i => <svg key={i} className="w-4 h-4 text-[#c9a84c]" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-462">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-463" />
                </svg>)}
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="p-6 md:p-8 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 relative" data-id="element-464">
            <QuoteIcon className="w-8 h-8 text-[#c9a84c]/20 absolute top-6 right-6" aria-hidden="true" data-id="element-465" />
            <div className="flex items-center gap-3 mb-5" data-id="element-466">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/30 to-[#252b45] flex items-center justify-center" data-id="element-467">
                <span className="text-[#c9a84c] font-bold text-sm" data-id="element-468">LH</span>
              </div>
              <div data-id="element-469">
                <p className="text-[#e8e6e1] font-semibold text-sm" data-id="element-470">
                  Laura Hernández
                </p>
                <p className="text-[#6b6b7b] text-xs" data-id="element-471">Ciudad de México</p>
              </div>
            </div>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-472">
              "La ansiedad me tenía paralizada.{' '}
              <span className="text-[#e8e6e1]" data-id="element-473">
                No podía dormir, no podía concentrarme
              </span>
              , sentía que mi mente era mi peor enemiga. Los audios de
              reprogramación fueron un antes y un después.
              <span className="text-[#c9a84c] italic" data-id="element-474">
                {' '}
                Hoy duermo en paz y ejecuto con claridad.
              </span>
              "
            </p>
            <div className="flex gap-0.5 mt-4" data-id="element-475">
              {[1, 2, 3, 4, 5].map(i => <svg key={i} className="w-4 h-4 text-[#c9a84c]" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-476">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-477" />
                </svg>)}
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="p-6 md:p-8 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 relative" data-id="element-478">
            <QuoteIcon className="w-8 h-8 text-[#c9a84c]/20 absolute top-6 right-6" aria-hidden="true" data-id="element-479" />
            <div className="flex items-center gap-3 mb-5" data-id="element-480">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/30 to-[#252b45] flex items-center justify-center" data-id="element-481">
                <span className="text-[#c9a84c] font-bold text-sm" data-id="element-482">CG</span>
              </div>
              <div data-id="element-483">
                <p className="text-[#e8e6e1] font-semibold text-sm" data-id="element-484">
                  Carlos García
                </p>
                <p className="text-[#6b6b7b] text-xs" data-id="element-485">Monterrey, Nuevo León</p>
              </div>
            </div>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-486">
              "Tengo 52 años y pensé que{' '}
              <span className="text-[#e8e6e1]" data-id="element-487">ya era tarde para cambiar</span>.
              Había probado de todo: libros, coaches, retiros espirituales. Nada
              permanente. Este protocolo fue diferente porque ataca la raíz.
              <span className="text-[#c9a84c] italic" data-id="element-488">
                {' '}
                Mis hijos me dicen que parezco 10 años más joven por la energía
                que tengo.
              </span>
              "
            </p>
            <div className="flex gap-0.5 mt-4" data-id="element-489">
              {[1, 2, 3, 4, 5].map(i => <svg key={i} className="w-4 h-4 text-[#c9a84c]" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-490">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-491" />
                </svg>)}
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="p-6 md:p-8 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 relative" data-id="element-492">
            <QuoteIcon className="w-8 h-8 text-[#c9a84c]/20 absolute top-6 right-6" aria-hidden="true" data-id="element-493" />
            <div className="flex items-center gap-3 mb-5" data-id="element-494">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/30 to-[#252b45] flex items-center justify-center" data-id="element-495">
                <span className="text-[#c9a84c] font-bold text-sm" data-id="element-496">MR</span>
              </div>
              <div data-id="element-497">
                <p className="text-[#e8e6e1] font-semibold text-sm" data-id="element-498">
                  María del Rosario López
                </p>
                <p className="text-[#6b6b7b] text-xs" data-id="element-499">Puebla, Puebla</p>
              </div>
            </div>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-500">
              "Soy madre de 3 hijos y{' '}
              <span className="text-[#e8e6e1]" data-id="element-501">
                me había perdido completamente
              </span>
              . No sabía quién era fuera de ser mamá. Este protocolo me devolvió
              mi identidad.
              <span className="text-[#c9a84c] italic" data-id="element-502">
                {' '}
                Empecé mi negocio, volví a hacer ejercicio y mi relación con mis
                hijos mejoró porque yo mejoré.
              </span>
              "
            </p>
            <div className="flex gap-0.5 mt-4" data-id="element-503">
              {[1, 2, 3, 4, 5].map(i => <svg key={i} className="w-4 h-4 text-[#c9a84c]" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-504">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-505" />
                </svg>)}
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}